import React from 'react';
import { Row, Col, Table, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';

import { CurrencyPlainText } from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import flatten from 'helpers/flatten';
import BootstrapTable from 'react-bootstrap-table-next';
import { renderToString } from 'react-dom/server'
import Select from 'react-select';

const ListingMarginVendor = ({
  reports,
  filters,
  stateFilters,
  handleFilterChange
}) => {
  const { t } = useTranslation();
  const handlePageChange = page => handleFilterChange({ page });
  const sortCaretDefaut = (order, column) => {
    if (!order) return (<i style={{float:'right'}} className="fas fa-sort"></i>);
    else if (order === 'asc') return (<i style={{float:'right'}} className="fas fa-sort-down"></i>);
    else if (order === 'desc') return (<i style={{float:'right'}} className="fas fa-sort-up"></i>);
    return null;
  };

  const columns = [
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center',
        fontSize: '15px'
      }
    },
    { 
      text: t('label:company'),
      dataField: 'name',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field })
      }
    },
    { 
      text: 'Verba',
      dataField: 'verba', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'margin.value' })
      },
      sortFunc: (a, b, order, dataField) => {
        let add_a = a.substring(1, 0)=='-'?-1:1;
        let add_b = b.substring(1, 0)=='-'?-1:1;
        a = parseFloat(a.replace(a.substring(3, 0),'').replace('.','').replace(',','.'))*add_a;
        b = parseFloat(b.replace(b.substring(3, 0),'').replace('.','').replace(',','.'))*add_b;
        if (order === 'desc') {
          return b - a;
        }
        return a - b;
      }
    },
    { 
      text: 'Valor Expirado', 
      dataField: 've', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'margin.expire' })
      },
      sortFunc: (a, b, order, dataField) => {
        let add_a = a.substring(1, 0)=='-'?-1:1;
        let add_b = b.substring(1, 0)=='-'?-1:1;
        a = parseFloat(a.replace(a.substring(3, 0),'').replace('.','').replace(',','.'))*add_a;
        b = parseFloat(b.replace(b.substring(3, 0),'').replace('.','').replace(',','.'))*add_b;
        if (order === 'desc') {
          return b - a;
        }
        return a - b;
      }
    },
    { 
      text: 'Gasto', 
      dataField: 'gasto', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'margin.expense' })
      },
      sortFunc: (a, b, order, dataField) => {
        let add_a = a.substring(1, 0)=='-'?-1:1;
        let add_b = b.substring(1, 0)=='-'?-1:1;
        a = parseFloat(a.replace(a.substring(3, 0),'').replace('.','').replace(',','.'))*add_a;
        b = parseFloat(b.replace(b.substring(3, 0),'').replace('.','').replace(',','.'))*add_b;
        if (order === 'desc') {
          return b - a;
        }
        return a - b;
      }
    },
    { 
      text: 'Margem', 
      dataField: 'margin', 
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'margin.margin' })
      },
      sortFunc: (a, b, order, dataField) => {
        let add_a = a.substring(1, 0)=='-'?-1:1;
        let add_b = b.substring(1, 0)=='-'?-1:1;
        a = parseFloat(a.replace(a.substring(3, 0),'').replace('.','').replace(',','.'))*add_a;
        b = parseFloat(b.replace(b.substring(3, 0),'').replace('.','').replace(',','.'))*add_b;
        
        if (order === 'desc') {
          return b - a;
        }
        return a - b;
      }
    },
  ];

  function btn(id) {
    return (<i className="fas fa-plus-circle btne" id={id}></i>)//<i className="fas fa-minus-circle"></i>;
  }

  const reportsData = [];
  let detailsArray = [];

  function getTableExport(btn_export){
    let teste = [];
    function getMore(report){
      let teste2 = [];
      report.actions.map(action=>{
        let detail = {
          id: action.id,
          type: 'Ação',
          value: action.margin.value,
          expire: action.margin.expire,
          gasto: action.margin.expense,
          margin: action.margin.margin,
        };
        teste2.push(detail);
      });
      report.marketing_plan.map(mp=>{
        let detail = {
          id: mp.id,
          type: 'Plano',
          value: mp.margin.value,
          expire: mp.margin.expire,
          gasto: mp.margin.expense,
          margin: mp.margin.margin,
        };
        teste2.push(detail);
      });
      return teste2;
    }

    var t = (
      <>
      <thead>
        <tr>
          <th>Fabricante</th>
          <th>Verba</th>
          <th>Valor Expirado</th>
          <th>Gasto</th>
          <th>Margem</th>
        </tr>
      </thead>
      <tbody>
        {Object.values(reports.data_export).map(report => {
          var item = {
            id: report.id,
            name: report.name+' / '+report.alias,
            verba: report.margin.value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            ve: report.margin.expire.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            gasto: report.margin.expense.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            margin: (report.margin.margin).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }),
            more: getMore(report),
            isExpandable:(report.marketing_plan.length>0 || report.actions.length>0?true:false)
          }
          const more = item =>{
            if(item.isExpandable){
              return(
                <table>
                  <thead>
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">Tipo</th>
                      <th scope="col">Valor</th>
                      <th scope="col">Gasto</th>
                      <th scope="col">Verba expirada</th>
                      <th scope="col">Margem</th>
                    </tr>
                  </thead>
                  <tbody>
                  {item.more.map(more=>{
                    return(
                      <tr>
                        <td>
                          {more.id}
                        </td>
                        <td>
                          {more.type}
                        </td>
                        <td>
                          {more.value.toLocaleString('pt-BR', {
                            style: 'currency',
                                        currency: 'BRL'
                                      }).replace(String.fromCharCode(160),' ')}
                        </td>
                        <td>
                          {more.gasto.toLocaleString('pt-BR', {
                            style: 'currency',
                                        currency: 'BRL'
                                      }).replace(String.fromCharCode(160),' ')}
                        </td>
                        <td>
                          {more.expire.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                          }).replace(String.fromCharCode(160),' ')}
                        </td>
                        <td>
                          {(more.margin).toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                      }).replace(String.fromCharCode(160),' ')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                </table> 
              );
            } else {
              return(
                <div>Sem Ação e Plano.</div>
              );
            }
          };
          return (
            <>
              <tr>
                <td>{item.name}</td>
                <td>{item.verba}</td>
                <td>{item.ve}</td>
                <td>{item.gasto}</td>
                <td>{item.margin}</td>
              </tr>
              <tr><td colspan="7">
              {more(item)}
              </td>
              </tr>
              <tr><td></td></tr>
              </>
            );
          })
        }
      </tbody>
      </>
    );
    document.getElementById("table-to-xls").innerHTML=renderToString(t);
    btn_export.disabled = false;
  } 

  async function getReports() {
    let teste = [];
    Object.values(reports.data).map(report => {
      teste = reportsData.push({
        btn: btn(report.id),
        id: report.id,
        name: report.name+' / '+report.alias,
        verba: report.margin.value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).replace(String.fromCharCode(160),' '),
        ve:  report.margin.expire.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).replace(String.fromCharCode(160),' '),
        gasto:  report.margin.expense.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).replace(String.fromCharCode(160),' '),
        margin: (report.margin.margin).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).replace(String.fromCharCode(160),' '),
        isExpandable:(report.marketing_plan.length>0 || report.actions.length>0?true:false)
      });
    });

    var btn_export = document.getElementById('btn-to-excel');
    if(btn_export!=null){
      await getTableExport(btn_export);
    }
  }

  getReports();

  const getDetails = rowId => {
    detailsArray = [];
    {
      Object.values(reports.data).map(report => {
        if(report.id === rowId){
          report.actions.map(action=>{
            let detail = {
              id: action.id,
              type: 'Ação',
              value: action.margin.value,
              expire: action.margin.expire,
              gasto: action.margin.expense,
              margin: action.margin.margin,
            };
            detailsArray.push(detail);
          });
          report.marketing_plan.map(mp=>{
            let detail = {
              id: mp.id,
              type: 'Plano',
              value: mp.margin.value,
              expire: mp.margin.expire,
              gasto: mp.margin.expense,
              margin: mp.margin.margin,
            };
            detailsArray.push(detail);
          });
        }
      });
    }
  };

  const expandRow = {
    renderer: row => (
      <>
        <div style={{display: row.isExpandable?'none':''}}>
        <p style={{textAlign: 'center'}}>{ `Sem Ação e Plano.` }</p>
        </div>
        <table bordered hover responsive className="table" style={{display: (row.isExpandable?'':'none')}}>
          <thead>
            <tr className="text-center align-middle">
              <th scope="col">ID</th>
              <th scope="col">Tipo</th>
              <th scope="col">Valor</th>
              <th scope="col">Gasto</th>
              <th scope="col">Verba Expirada</th>
              <th scope="col">Margem</th>
            </tr>
          </thead>
          <tbody className="table">
            {getDetails(row.id)}
            {detailsArray.map(info => (
              <tr key={info.id} className="text-center align-middle">
                <td className="text-center align-middle">
                  {info.id}
                </td>
                <td className="text-center align-middle">
                  {info.type}
                </td>
                <td className="text-center align-middle">
                  {info.value.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
                <td className="text-center align-middle">
                  {info.gasto.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
                <td className="text-center align-middle">
                  {info.expire.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
                <td className="text-center align-middle">
                  {(info.margin).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                              })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    ),
    onlyOneExpanding: true,
    onExpand: (row,isExpand)=>{
      var btn = document.getElementById(row.id);
      if(isExpand){
        btn.classList.add('fa-minus-circle');
        btn.classList.remove('fa-plus-circle');
      } else {
        btn.classList.remove('fa-minus-circle');
        btn.classList.add('fa-plus-circle');
      }
      var btns = Object.values(document.getElementsByClassName('btne'));
      btns.map(btn=>{
        if(btn.id != row.id)
        if(btn.classList.contains('fa-minus-circle')){
          btn.classList.remove('fa-minus-circle');
          btn.classList.add('fa-plus-circle');
        }
      })
    }
  };
  
  const getCompanies = companies => {
    let itens = [];
    Object.values(companies).map(company=>{
      itens.push({
        label: company.alias,
        value: company.id
      });
    });
    return itens;
  }

  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:company')}:</Form.Label>
                <Select
                  defaultValue={{ label: 'Todos', value: '' }}
                  selectedValue={stateFilters.vendor}
                  name="vendor"
                  options={[
                    ...[{ label: 'Todos', value: '' }],
                    ...getCompanies(reports.vendor)
                  ]}
                  //onClick={stateFilters[filter.key]}
                  placeholder={t('label:select')}
                  onChange={e =>
                    handleFilterChange({ vendor: e.value, page:1 })
                  }
                  noOptionsMessage={() =>
                    getCompanies(reports.vendor).length == 0
                      ? t('label:loading')
                      : 'No Options'
                  }
                />
              </Form.Group>
            </Col>
            {filters.map((filter, k) => (
              <Col key={k} md={2}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={e =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.search}
                  onChange={e => handleFilterChange({ search: e.target.value, page:1 })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
          <Col>
              <BootstrapTable
                id="vendor-report-table"
                keyField="id"
                data={reportsData}
                columns={columns}
                bordered hover responsive
                rowStyle={{fontSize: '13px'}}
                noDataIndication="Valor não Encontrado"
                expandRow={expandRow}
                classes="table-condensed"
                wrapperClasses='table-responsive'
              />
              <table bordered hover responsive id="table-to-xls" 
                style={{display:'none'}}
              ></table>
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.from || '0' }} to{' '}
                {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.current_page}
                itemsCountPerPage={reports.per_page}
                totalItemsCount={reports.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingMarginVendor;
